export default "__VITE_ASSET__r$Gidefk__"